import { useRef } from "react";
import InsertNamesToTable from "./InsertNamesToTable";


const NamesTable =  ({namesList, onDoubleClick, clcikEnable, setClickEnable}) => {
    const Parent = useRef();

    const clickAddToList = (key, e, value) => {
        let [clcikEnableKey, clcikEnableId] = clcikEnable;
        const [indexKey, indexId] = [clcikEnableKey.indexOf(key), clcikEnableId.indexOf(value)];
        indexKey !== -1 && clcikEnableKey.splice(indexKey, 1) && clcikEnableId.splice(indexId, 1); // if the value exists, delete it
        ! e.ctrlKey && (clcikEnableKey = []) && (clcikEnableId = []); // if Control is not pressed, delete everything
        indexKey === -1 && clcikEnableKey.push(key) && clcikEnableId.push(value); // if the value does not exist, add it
        setClickEnable([clcikEnableKey, clcikEnableId]);
        for (let c of Parent.current.children) {
            c.className = clcikEnableKey.includes(Number(c.children[0].innerHTML)) ? 'grayTable' : '';
        }
    }

    return (
        <div className="scrool NamesTable">
            <InsertNamesToTable 
            data={namesList}
            onDoubleClick={(key) => onDoubleClick(key, {...namesList[key]})}
            onClick={clickAddToList}
            Parent={Parent}
            />
        </div>
    )
}

export default NamesTable;